import React, { createContext } from 'react';

const ReportsContext = createContext();

export default ReportsContext;
